export enum TaskListMode {
  general,
  leg,
}
